import type { NamespaceCatalog } from '@/i18n/ns';
const en = {
  save: 'Save edit',
  saving: 'Saving…',
  guidance: 'Save your edit, then send a message to continue from here.',
  failed: 'Your edit could not be saved. Try again.',
};
export type ChatRepairKey = keyof typeof en;
type Copy = Record<ChatRepairKey, string>;
const bg: Copy = {
  save: 'Запазване на редакцията',
  saving: 'Запазване…',
  guidance: 'Запазете редакцията и изпратете съобщение, за да продължите оттук.',
  failed: 'Редакцията не бе запазена. Опитайте отново.',
};
const cs: Copy = {
  save: 'Uložit úpravu',
  saving: 'Ukládání…',
  guidance: 'Uložte úpravu a pošlete zprávu, abyste pokračovali odtud.',
  failed: 'Úpravu se nepodařilo uložit. Zkuste to znovu.',
};
const da: Copy = {
  save: 'Gem ændring',
  saving: 'Gemmer…',
  guidance: 'Gem ændringen, og send en besked for at fortsætte herfra.',
  failed: 'Ændringen kunne ikke gemmes. Prøv igen.',
};
const de: Copy = {
  save: 'Änderung speichern',
  saving: 'Speichern…',
  guidance: 'Speichern Sie die Änderung und senden Sie eine Nachricht, um hier fortzufahren.',
  failed: 'Ihre Bearbeitung konnte nicht gespeichert werden. Versuchen Sie es erneut.',
};
const el: Copy = {
  save: 'Αποθήκευση αλλαγής',
  saving: 'Αποθήκευση…',
  guidance: 'Αποθηκεύστε την αλλαγή και στείλτε μήνυμα για να συνεχίσετε από εδώ.',
  failed: 'Η αλλαγή δεν αποθηκεύτηκε. Δοκιμάστε ξανά.',
};
const es: Copy = {
  save: 'Guardar edición',
  saving: 'Guardando…',
  guidance: 'Guarda la edición y envía un mensaje para continuar desde aquí.',
  failed: 'No se pudo guardar la edición. Inténtalo de nuevo.',
};
const et: Copy = {
  save: 'Salvesta muudatus',
  saving: 'Salvestamine…',
  guidance: 'Salvesta muudatus ja saada sõnum, et siit jätkata.',
  failed: 'Muudatust ei saanud salvestada. Proovi uuesti.',
};
const fi: Copy = {
  save: 'Tallenna muutos',
  saving: 'Tallennetaan…',
  guidance: 'Tallenna muutos ja lähetä viesti jatkaaksesi tästä.',
  failed: 'Muutosta ei voitu tallentaa. Yritä uudelleen.',
};
const fr: Copy = {
  save: 'Enregistrer la modification',
  saving: 'Enregistrement…',
  guidance: 'Enregistrez la modification, puis envoyez un message pour continuer ici.',
  failed: 'La modification n’a pas été enregistrée. Réessayez.',
};
const ga: Copy = {
  save: 'Sábháil an t-athrú',
  saving: 'Ag sábháil…',
  guidance: 'Sábháil an t-athrú agus seol teachtaireacht chun leanúint ar aghaidh anseo.',
  failed: 'Níor sábháladh an t-athrú. Bain triail eile as.',
};
const hr: Copy = {
  save: 'Spremi izmjenu',
  saving: 'Spremanje…',
  guidance: 'Spremite izmjenu i pošaljite poruku da nastavite odavde.',
  failed: 'Izmjena nije spremljena. Pokušajte ponovno.',
};
const hu: Copy = {
  save: 'Módosítás mentése',
  saving: 'Mentés…',
  guidance: 'Mentsd a módosítást, majd küldj üzenetet a folytatáshoz.',
  failed: 'A módosítást nem sikerült menteni. Próbáld újra.',
};
const it: Copy = {
  save: 'Salva modifica',
  saving: 'Salvataggio…',
  guidance: 'Salva la modifica e invia un messaggio per continuare da qui.',
  failed: 'Impossibile salvare la modifica. Riprova.',
};
const lt: Copy = {
  save: 'Išsaugoti pakeitimą',
  saving: 'Išsaugoma…',
  guidance: 'Išsaugokite pakeitimą ir siųskite žinutę, kad tęstumėte nuo čia.',
  failed: 'Pakeitimo nepavyko išsaugoti. Bandykite dar kartą.',
};
const lv: Copy = {
  save: 'Saglabāt labojumu',
  saving: 'Saglabā…',
  guidance: 'Saglabājiet labojumu un nosūtiet ziņu, lai turpinātu no šejienes.',
  failed: 'Labojumu neizdevās saglabāt. Mēģiniet vēlreiz.',
};
const mt: Copy = {
  save: 'Issejvja l-bidla',
  saving: 'Qed jissejvja…',
  guidance: 'Issejvja l-bidla u ibgħat messaġġ biex tkompli minn hawn.',
  failed: 'Il-bidla ma setgħetx tiġi ssejvjata. Erġa’ pprova.',
};
const nl: Copy = {
  save: 'Wijziging opslaan',
  saving: 'Opslaan…',
  guidance: 'Sla de wijziging op en stuur een bericht om vanaf hier verder te gaan.',
  failed: 'De wijziging kon niet worden opgeslagen. Probeer het opnieuw.',
};
const pl: Copy = {
  save: 'Zapisz zmianę',
  saving: 'Zapisywanie…',
  guidance: 'Zapisz zmianę i wyślij wiadomość, aby kontynuować od tego miejsca.',
  failed: 'Nie udało się zapisać zmiany. Spróbuj ponownie.',
};
const pt: Copy = {
  save: 'Guardar edição',
  saving: 'A guardar…',
  guidance: 'Guarda a edição e envia uma mensagem para continuar daqui.',
  failed: 'Não foi possível guardar a edição. Tenta novamente.',
};
const ro: Copy = {
  save: 'Salvează modificarea',
  saving: 'Se salvează…',
  guidance: 'Salvează modificarea și trimite un mesaj pentru a continua de aici.',
  failed: 'Modificarea nu a putut fi salvată. Încearcă din nou.',
};
const sk: Copy = {
  save: 'Uložiť úpravu',
  saving: 'Ukladanie…',
  guidance: 'Uložte úpravu a odošlite správu, aby ste pokračovali odtiaľto.',
  failed: 'Úpravu sa nepodarilo uložiť. Skúste to znova.',
};
const sl: Copy = {
  save: 'Shrani spremembo',
  saving: 'Shranjevanje…',
  guidance: 'Shrani spremembo in pošlji sporočilo za nadaljevanje od tu.',
  failed: 'Spremembe ni bilo mogoče shraniti. Poskusi znova.',
};
const sv: Copy = {
  save: 'Spara ändring',
  saving: 'Sparar…',
  guidance: 'Spara ändringen och skicka sedan ett meddelande för att fortsätta härifrån.',
  failed: 'Ändringen kunde inte sparas. Försök igen.',
};
export const chatRepairCopy: NamespaceCatalog<ChatRepairKey> = {
  bg,
  cs,
  da,
  de,
  el,
  en,
  es,
  et,
  fi,
  fr,
  ga,
  hr,
  hu,
  it,
  lt,
  lv,
  mt,
  nl,
  pl,
  pt,
  ro,
  sk,
  sl,
  sv,
};
export default chatRepairCopy;
